<template>
<el-dialog @close='cancel' title="选择试卷" :visible.sync="dialogVisible">
    <div class="add_goods_box">
        <div class="add_goods_search_box">
            <el-button type="primary" style="margin-left: 0" @click="routeCreate">新建试卷</el-button>
            <el-input placeholder="输入试卷名称" v-model="param.subject" clearable style="margin-left: 90px"></el-input>
            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
        </div>
        <div class="add_goods_tabs_box">
            <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
                <el-tab-pane :label="item.label" :name="item.name" v-for="(item,index) in activeList" :key="index">
                    
                    <p v-if="tableData && tableData.length == 0" style="text-align:center; margin-top: 40px;">当前暂无试卷，请前往<el-button type="text" @click="routeCreate" style="min-width:auto">新建试卷</el-button></p>
                    <div class="scrollBox" v-else>
                        <el-table :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange" :ref="'multipleTable'+item.name">
                            <el-table-column type="selection" width="30"></el-table-column>
                            <el-table-column label="试卷信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <img v-lazy="scope.row.coverurl" alt>
                                        <div>
                                            <p>{{scope.row.name}}</p>
                                            <p :class="scope.row.isFree === 1 ? 'free' : 'toll'">{{scope.row.isFree === 1 ? scope.row.isFreeText : scope.row.salePrice}}</p>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="more" @click="_getList" v-if="showMore">点击加载更多</div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>  
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureAdd()">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {getAllExampaperInfo} from 'api/testPaperApi'
// import {findGoodsList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shop',
    data() {
        return {
            activeList: [{label: '试卷', name: 'testPaper'}], //  {label: '视频', name: 'video'}, {label: '专题', name: 'spackage'}
            activeName: 'testPaper',
            param: {
                status: 2,
                subject: '',
                quescount: '0'
                // kmctype: 4
            },
            page: {
                page: 0,
                pagesize: 10,
                pagecount: 0
            },
            refName: '',
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            flag: true,
            scrollTop: 0, // 上一次滚动距离
            showMore: false
        }
    },
    mounted() {},
    methods: {
        openDialog(selectedResult) {
            this.tableData = []
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.subject = ''
            this.page = {
                page: 0,
                pagesize: 10,
                pagecount: 0
            }
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 添加分组弹窗Tabs
        handleClick(tabName) {
            switch (tabName) {
            case 'testPaper':
                // this.param.kmctype = 4
                break
            }
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 获取不同类型下商品列表
        _getList() {
            let selectedResult = this.selectedResult
            this.page.page++
            this.setLoading(true)
            getAllExampaperInfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data.content)
                    this.total = data.data.pageinfo.rowCount
                    this.page.pagecount = data.data.pageinfo.pagecount
                    if (this.tableData.length >= this.total) {
                        this.showMore = false
                    } else {
                        this.showMore = true
                    }
                    if (selectedResult.length) {
                        this.tableData.forEach(obj1 => {
                            selectedResult.forEach(obj2 => {
                                if (obj1.innerid === obj2.objectid) {
                                    this.$nextTick(() => {
                                        this.$refs[`multipleTable${this.activeName}`][0].toggleRowSelection(obj1)
                                    })
                                }
                            })
                        })
                    }
                    this.setLoading(false)
                    let _this = this
                    // this.$nextTick(() => {
                    //     $('.el-table__body-wrapper').scroll(function () {
                    //         let scrollTop = Math.floor(this.scrollTop)
                    //         let clientHeight = this.clientHeight
                    //         let scrollHeight = Math.floor(this.scrollHeight)
                    //         if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                    //             if (_this.page.page < _this.page.pagecount) {
                    //                 _this.scrollTop = this.scrollTop
                    //                 _this._getList()
                    //             }
                    //         }
                    //     })
                    // })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        handleSelectionChange(selection, row) {

            this.$refs[`multipleTable${this.activeName}`][0].clearSelection()
            if (selection.length > 1) {
                this.$refs[`multipleTable${this.activeName}`][0].clearSelection()
                // this.$refs[`multipleTable${this.activeName}`].clearSelection()
            }
            this.$refs[`multipleTable${this.activeName}`][0].toggleRowSelection(selection.pop())

            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.innerid) {
                    flag = false
                    // this.selectedResult.splice(index1, 1)
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                let arr = {
                    exampaperinnerid: row.innerid,
                    exampapername: row.name,
                    // kmctype: row.kmctype,
                    viewcount: row.viewcount,
                    uprice: row.uprice,
                    saleprice: row.saleprice,
                    eqcoverurl: row.coverurl,
                    desc: row.desc   
                }
                
                this.selectedResult = []
                // selection = []
                // selection.push(arr)
                this.selectedResult.push(arr)
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
        },
        // 确定添加商品
        sureAdd() {
            this.$emit('setShop', this.selectedResult)
            this.cancel()
        },
        routeCreate() {
            this.$router.push({name: "TestpaperEdit", query: {type: 'add'}})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.add_goods_box {
    .add_goods_search_box {
        display: flex;
        margin-bottom: 10px;
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 36px;
        }
        .el-button,
        .el-button--mini {
            height: 36px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .scrollBox {
            max-height: 300px;
            overflow-y: scroll;
            .more {
                text-align: center;
                line-height: 30px;
                cursor: pointer;
                &:hover {
                    color: #409EFF;
                }
            }
        }
        .el-table{
            min-height: 300px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            & > img {
                width: 74px;
                min-width: 74px;
                height: 42px;
                margin-right: 10px;
            }
            & > div {
                & > p:nth-of-type(1) {
                    color: rgba(48, 49, 51, 1);
                    line-height: 18px;
                    margin-bottom: 4px;
                    width: 420px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                & > p:nth-of-type(2) {
                    line-height: 20px;
                }
                .free {
                    color: rgba(64, 158, 255, 1);
                }
                .toll {
                    color: #f56c6c;
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-tabs__header {
        padding-right: 20px;
    }
}
</style>
